export const SchedulerDetailsConstants = {
  DURATION: 30,
  MAX_HOURS: 24,
  BOOKED_EVENT_PROPS: {
    duration: 30,
    end: undefined,
    start: undefined,
    category: 'booked',
    title: 'Interview booked',
    backgroundColor: 'var(--kula-colors-primary-500)',
    borderColor: 'var(--kula-colors-primary-500)',
    textColor: 'var(--kula-colors-base-white)',
    editable: true,
    extendedProps: {
      priority: 1,
      category: 'booked',
      description: 'booked for interview',
      type: 'booked',
    },
  },
};
